import store from "@/store/store";

export function hasAnyPermission(check) {
  const organization = store.getters["organization/selected"];
  const permissions = store.getters["organization/selectedOrganizationPermissions"];
  const account = store.getters["user/account"];

  if (!organization || !account) {
    return false;
  }

  if (account._id == organization.createdBy?._id) {
    return true;
  }
  return permissions.some((p) => p == "ORGANIZATION_ADMIN" || check.includes(p));
}

export function createRule(fnc, redirect = -1) {
  return (routeTo, routeFrom) => {
    return {
      redirect: typeof redirect === "function" ? redirect(routeTo, routeFrom) : redirect,
      rule() {
        return fnc(routeTo, routeFrom);
      },
    };
  };
}

export function canOrganizationAccessProduct(product) {
  const organization = store.getters["organization/selected"];
  return organization?.features?.accessableProducts?.includes(product);
}

// Generic Rules

export const isLoggedIn = createRule(
  (routeTo, routeFrom) => {
    return !!store.getters["user/jwt"];
  },
  (routeTo, routeFrom) => {
    return routeTo.path ? "/login?redirectUrl=" + routeTo.path : "/login";
  }
);

//
//
export const isNotLoggedIn = createRule(() => {
  return !store.getters["user/jwt"];
});
export const isOrganizationSelected = createRule(() => !!store.getters["organization/selected"], "/403");

export const isAccountTypeSystem = createRule(() => store.getters["user/account"]?.type == "system", "/");
export const isAdminOrOwnerOfAnyWorkpace = createRule(() => !!store.getters["user/isAdminOrOwnerOfAnyWorkpace"], "/");

export const isAdminOfDepartmentOrProcess = createRule(() => !!store.getters["user/account"]?.adminEntities?.isDepartmentOrProcessAdmin, "/");

export const isOrganizationAdmin = createRule(() => hasAnyPermission(["ORGANIZATION_ADMIN"]));
export const isWorkspaceAdmin = createRule(() => {
  const selectedWorkspace = store.getters["switchWorkspace/selected"];
  if (!selectedWorkspace) {
    return false;
  }

  const account = store.getters["user/account"];

  return selectedWorkspace.owner._id == account._id || selectedWorkspace.role?.definition == "WORKSPACE_ADMIN";
}, "/403");

export const canGetOrganizationSettingsPage = createRule(() =>
  hasAnyPermission([
    //!ürün yönetici/kullanıcıları, başka rolleri yoksa sadece kendi ürünlerine erişsinler
    // "ORGANIZATION_GDPR_PRODUCT_ADMIN",
    // "ORGANIZATION_KVKK_PRODUCT_ADMIN",
    // "ORGANIZATION_DDO_PRODUCT_ADMIN",
    "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
    "ORGANIZATION_LEGAL_ADMIN",
    "ORGANIZATION_RISK_ADMIN",
  ])
);

export const canGetGdprFileManagerPage = createRule(
  () =>
    canOrganizationAccessProduct("GDPR") &&
    hasAnyPermission([
      "ORGANIZATION_GDPR_PRODUCT_ADMIN",
      "ORGANIZATION_GDPR_ACCESS",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetKvkkFileManagerPage = createRule(
  () =>
    canOrganizationAccessProduct("KVKK") &&
    hasAnyPermission([
      "ORGANIZATION_KVKK_PRODUCT_ADMIN",
      "ORGANIZATION_KVKK_ACCESS",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetDDOFileManagerPage = createRule(
  () =>
    canOrganizationAccessProduct("DDO") &&
    hasAnyPermission([
      "ORGANIZATION_DDO_PRODUCT_ADMIN",
      "ORGANIZATION_DDO_ACCESS",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetRiskDecisionPage = createRule(() => hasAnyPermission(["ORGANIZATION_RISK_ADMIN"]));

export const canGetGdprLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("GDPR") &&
    hasAnyPermission([
      "ORGANIZATION_GDPR_PRODUCT_ADMIN",
      "ORGANIZATION_GDPR_ACCESS",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetKvkkLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("KVKK") &&
    hasAnyPermission([
      "ORGANIZATION_KVKK_PRODUCT_ADMIN",
      "ORGANIZATION_KVKK_ACCESS",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetDdoLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("DDO") &&
    hasAnyPermission([
      "ORGANIZATION_DDO_PRODUCT_ADMIN",
      "ORGANIZATION_DDO_ACCESS",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetBgysLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("BGYS") &&
    hasAnyPermission([
      "ORGANIZATION_ADMIN",
      "ORGANIZATION_BGYS_PRODUCT_ADMIN",
      "ORGANIZATION_BGYS_ACCESS",
      "ORGANIZATION_RISK_PRODUCT_ADMIN",
      "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);

export const canGetRiskLayoutPages = createRule(
  () =>
    canOrganizationAccessProduct("RISK") &&
    hasAnyPermission([
      "ORGANIZATION_RISK_PRODUCT_ADMIN",
      "ORGANIZATION_RISK_ACCESS",
      // "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
      "ORGANIZATION_LEGAL_ADMIN",
      "ORGANIZATION_RISK_ADMIN",
    ])
);
